import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
// import { removeHTML } from '../../utils'
// import { ProgressBar } from '../ProgressBar'
// import flecha_s from "../HeaderCourses/assets/flecha-s.png";
import logoSence from '../../assets/LOGO-SENCE-SIN-FONDO.png'

export const CourseCard = ({ item = null, moodle, lang, imgurl, notEnrrolled = false }) => {
  /*   const enddate = new Date(item.startdate).toDateString() */
  /*   const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }; */
  const theme = useTheme();
  const navigation = useNavigate();
  const backgroundref = React.useRef(null);



  const handleNavigation = (percentage) => {
    /* navigation(`/detailcourse/${percentage}/${item.id}`); */
    // localStorage.setItem("courseProgress", JSON.stringify(percentage));
    moodle.setCurrentModules(null);
    navigation(`/detailcourse/${item.id}`);
  };

  return (
    <div
      className="my-5 rounded-[14px] border-[1px] border-slate-200/30 shadow-md hover:shadow-2xl transition-shadow duration-300 max-w-[320px]"
      style={{
        boxShadow: theme.mode === "dark" ? "#f5f5f5" : "#18232d", // TODO: Pasar a Theme Context
        filter: notEnrrolled ? "brightness(0.9)" : '',
        opacity:notEnrrolled ? 0.8 : 1
      }}
      
    >
      <div
        className={`flex flex-col justify-between h-full rounded-[14px] overflow-hidden`}
        style={{
          backgroundColor: theme.mode === "dark" ? "#060036" : "#EDEDED", // TODO: Pasar a Theme Context

        }}
      >
        {/* Imagen */}
        <div
          ref={backgroundref}
          style={{backgroundImage: `url(${imgurl})`}}
          className="h-[180px] w-full bg-gray-300 bg-cover bg-center"
          alt="imagen del curso"
        />
        {item && item.idnumber?.includes("sence") &&<div className="relative">
        <img src={logoSence} alt="logo-sence" className="w-28 h-auto absolute right-0 bottom-0 drop-shadow-lg m-2 " /> 

        </div>}

        <section className="flex flex-col px-4 py-2 min-h-[200px]">
          {/* Nombre */}
          <h2
            className="text-lg font-outfit font-medium px-4 text-left mt-4 laptop:text-2xl line-clamp-3"
            style={{color: theme.mode === "light" ? "#16232c" : "#fff"}}
            title={item.fullname}
          >
            {item.fullname}
          </h2>

          {/* Progressgdshfgkjfho */}
          <div className="flex flex-col flex-grow px-4 py-3">
            {/* <progress
              id="file"
              max="100"
              value={item?.progress?.toFixed(0) || 0}
              className="w-full h-2 rounded-full overflow-hidden appearance-none"
            >
              {item?.progress?.toFixed(0) || 0}%
            </progress> */}
            <p
              className="mt-2 text-lg font-lato font-medium text-left"
              style={{color: theme.mode === "light" ? "#16232c" : "#fff"}} // TODO: Cambiar Styles por Colors
            >
              {item?.progress?.toFixed(0) || 0}% Completado
            </p>
          </div>

          {/* Botón de ingreso */}
          <div className="px-4 pb-4 flex justify-center mt-auto">
            <button
              onClick={handleNavigation}
              type="button"
              style={{ backgroundColor: notEnrrolled ? "rgb(97 144 169)": theme.colors.backgroundColorCardBtn, cursor: notEnrrolled ? 'not-allowed' : 'pointer' }}
              className="flex items-center justify-center w-[280px] h-[42px] gap-2 py-2 px-4 rounded-xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            >
              <span
                className="font-semibold text-2xl"
                style={{ color: theme.colors.TextColorCardBtn }}
              >
                {lang["Home"].course_btn}
              </span>
            </button>
          </div>
        </section>
        {/* Nombre */}
      </div>
    </div>
  );
};

